import { Application as StimulusApplication } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import { captureHostAttribution } from "../../resources/ts/bookingWidget/attribution";
// Ad-click attribution: remember the Google Ads click id / UTM tags on the FIRST page a visitor
// lands on (the listing page), not only on the boat page that hosts the widget. Boat card links
// drop the query string, so without this the click id was lost before the widget ever loaded.
captureHostAttribution();
const stimulus = StimulusApplication.start();
const context = require.context("./scripts/stimulus", true, /\.ts$/);
stimulus.load(definitionsFromContext(context));
